import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useCallback, useMemo } from 'react';
import styled, { StyleSheetManager } from 'styled-components';
import { PageLoading } from 'components/atoms/loading';
import { LocaleIntlProvider } from 'components/i18n/LocaleIntlProvider';
import { useWithAccess } from 'hooks/rbac/useWithAccess';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { NotFound } from 'routes/404';
const SkillBuilderApp = /*#__PURE__*/ React.lazy(()=>import('agentBuilder/SkillBuilderApp').then((module)=>({
            default: module.SkillBuilderApp
        })));
// Lazy: SheetInChatView is only invoked when the remote host renders a
// 'sheet_instance' request — keep the sheets graph out of the shell.
const SheetInChatView = /*#__PURE__*/ React.lazy(()=>import('components/organisms/sheets/sheet-in-chat/sheet-in-chat-view').then((m)=>({
            default: m.SheetInChatView
        })));
const SkillBuilderWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
export const SkillBuilderRemote = ()=>{
    const { hasAccessToResource } = useWithAccess();
    const [isWorkforceAgentBuilderEnabled] = useAccountFeature(AccountFeature.WorkforceAgentBuilderEnabled);
    const renderComponent = useCallback((request)=>{
        switch(request.type){
            case 'sheet_instance':
                {
                    const props = request.props;
                    return /*#__PURE__*/ _jsx(LocaleIntlProvider, {
                        fallbackOnEmptyString: true,
                        children: /*#__PURE__*/ _jsx(Suspense, {
                            fallback: null,
                            children: /*#__PURE__*/ _jsx(SheetInChatView, {
                                projectId: props.projectId,
                                sheetId: props.sheetId,
                                versionId: props.versionId,
                                tabId: props.sheetTabId,
                                readonly: props.readonly,
                                sourceType: props.sourceType,
                                sourceId: props.sourceId,
                                showInfoBar: props.showInfoBar,
                                ruleIds: props.ruleIds,
                                conversationId: props.conversationId,
                                validationType: props.validationType
                            })
                        })
                    });
                }
            case 'loading':
                {
                    const props = request.props;
                    return /*#__PURE__*/ _jsx(LocaleIntlProvider, {
                        fallbackOnEmptyString: true,
                        children: /*#__PURE__*/ _jsx(PageLoading, {
                            size: props.size
                        })
                    });
                }
            default:
                return null;
        }
    }, []);
    const hostAPI = useMemo(()=>({
            renderComponent,
            hasAccessToResource
        }), [
        renderComponent,
        hasAccessToResource
    ]);
    if (!isWorkforceAgentBuilderEnabled) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(PageLoading, {}),
        children: /*#__PURE__*/ _jsx(StyleSheetManager, {
            target: document.head,
            children: /*#__PURE__*/ _jsx(SkillBuilderWrapper, {
                "data-cy": "skill-builder-container",
                className: "cp-pt-2 cp-pb-2 cp-pl-0 cp-pr-2",
                children: /*#__PURE__*/ _jsx(SkillBuilderApp, {
                    hostAPI: hostAPI
                })
            })
        })
    });
};
